export const REGULAR = 'reconnect-guide';
export const NOT_CRITICAL = 'reconnect-guide-not-critical';
export const CRITICAL = 'reconnect-guide-critical';
